module.exports = __webpack_public_path__ + "media/public/images/about/services/04-eea8effbdd245d57f9ab1967dbc7eba5.jpg";